module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "position": "relative"
    },
    style: ({
      height: _vm.height,
      width: _vm.width
    }),
    attrs: {
      "element-loading-text": "频谱分析中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    }
  }, [_c('div', {
    style: ({
      height: _vm.height,
      width: _vm.width
    }),
    attrs: {
      "id": "spectrum-line"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-2d718f60"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/chartsNoise/SpectrumLine.vue
// module id = 1895
// module chunks = 1